import 'core-js/fn/array/find';
import 'core-js/fn/array/find-index';
import 'core-js/fn/array/includes';
import 'core-js/fn/object/assign';
import 'core-js/fn/object/set-prototype-of';
import 'core-js/fn/object/get-prototype-of';
import 'core-js/fn/string/starts-with';
import 'core-js/es6/symbol';



// WEBPACK FOOTER //
// ./src/util/polyfill.js